import { globalStore, useGlobalStore } from '@stores';
import { flint } from './request';
import { useStateful } from 'react-hanger';
import { useEffect } from 'react';
import { storage } from 'lib/index';

let globalPageConfig = {
  enablePartyRoom: false,
  partyStreamType: 'zego',
  enableAudioText: false,
  directToCdn: true,
  enable_im: true,
  enableHeartbeatPk: false,
  enableMaskPk: false,
  enableRacePk: false,
  enableOath: false,
  enableWeibo: false,
  hardwareEncoder: {},
  agoraHardwareEncoder: {},
  bitRate: {
    anchorRoom: [800, 1500],
    anchorRoomPortrait: [800, 2500],
    anchorRoomJoinLive: [600, 1000],
    topc: [1200, 1500],
    sm: [50, 100],
    pk_host: [50, 100],
    pk_star: [200, 400],
  },
  zgConfig: {
    horizontal: false,
    videoQuality: 4,
    width: 640,
    height: 480,
    // width: 1280,
    // height: 720,
    // width: 800,
    // height: 600,
    frameRate: 15,
    bitRate: {
      minBitRate: 400,
      maxBitRate: 2500,
    },
    audioBitRate: 96000,
    noiseSuppression: true,
    autoGainControl: true,
    echoCancellation: true,
  },
  default3A: {
    noiseSuppression: false,
    autoGainControl: false,
    echoCancellation: false,
  },
  joinLine3A: {
    noiseSuppression: true,
    autoGainControl: true,
    echoCancellation: true,
  },
  publishStreamConfig: {
    anchorRoom: {
      width: 800,
      height: 600,
      bitRate: {
        minBitRate: 800,
        maxBitRate: 1200,
      },
    },
    anchorRoomJoinLive: {
      width: 640,
      height: 480,
      bitRate: {
        minBitRate: 600,
        maxBitRate: 1000,
      },
    },

    anchorRoomPortrait: {
      width: 720,
      height: 1280,
      bitRate: {
        minBitRate: 1000,
        maxBitRate: 2500,
      },
    },
    anchorRoomJoinLivePortrait: {
      width: 720,
      height: 1280,
      bitRate: {
        minBitRate: 1000,
        maxBitRate: 1500,
      },
    },

    topc: {
      width: 640,
      height: 480,
      bitRate: {
        minBitRate: 800,
        maxBitRate: 1200,
      },
    },
    sm: {
      width: 640,
      height: 480,
      bitRate: {
        minBitRate: 50,
        maxBitRate: 100,
      },
    },
    pk_host: {
      width: 640,
      height: 480,
      bitRate: {
        minBitRate: 50,
        maxBitRate: 100,
      },
    },
    pk_star: {
      width: 640,
      height: 480,
      bitRate: {
        minBitRate: 200,
        maxBitRate: 400,
      },
    },

    clientDefault: {
      width: 960,
      height: 720,
      // width: 800,
      // height: 600,
      bitRate: {
        minBitRate: 1000,
        maxBitRate: 2000,
      },
    },
    clientMultiPk: {
      width: 480,
      height: 360,
      bitRate: {
        minBitRate: 400,
        maxBitRate: 1000,
      },
    },
    clientPortrait: {
      width: 480,
      height: 720,
      bitRate: {
        minBitRate: 1000,
        maxBitRate: 2000,
      },
    },
  },

  highPublishStreamConfig: {
    clientDefault: {
      width: 960,
      height: 720,
      frameRate: 30,
      bitRate: {
        minBitRate: 1000,
        maxBitRate: 3000,
      },
    },
    clientPortrait: {
      width: 1080,
      height: 1920,
      frameRate: 30,
      bitRate: {
        minBitRate: 1000,
        maxBitRate: 3000,
      },
    },
  },
  来疯直播助手: {
    clientDefault: {
      // 兼容
      captureWidth: 1280,
      captureHeight: 720,
      width: 960,
      height: 720,
    },
  },
  '9ShowMateVC': {
    clientDefault: {
      // 兼容
      width: 800,
      height: 600,
    },
  },
};

const init = () => {
  flint
    .get('api/v1/apps/meme/www/global_page_config')
    .then((res: any) => {
      globalPageConfig = res.data;
      // globalPageConfig.partyStreamType = 'zego'
      globalStore.setGlobalPageConfigReady(true);

      // 防止别人内嵌
      const reg = res.data.disableHost?.join('|');
      if (reg && new RegExp(reg).test(location.hostname)) {
        location.href = 'h t t p s : / / w w w . 2 3 3 9.c o m'.replace(/\s/g, '');
      }
    })
    .catch((err: any) => {});
};

const getConfig = () => {
  return globalPageConfig;
};

const customStreamOptions = {
  isHigh: false,
  // 是否启用
  enable: false,
  clientDefault: {
    width: 800,
    height: 600,
    // width: 800,
    // height: 600,
    bitRate: {
      minBitRate: 1000,
      maxBitRate: 2000,
    },
  },
  clientPortrait: {
    width: 720,
    height: 1280,
    bitRate: {
      minBitRate: 1000,
      maxBitRate: 2000,
    },
  },
};

const cacheStreamConfig = {};

const getStreamSize = (streamType) => {
  return cacheStreamConfig[streamType] || globalPageConfig.publishStreamConfig[streamType];
};

const setCustomStreamOptions = (options) => {
  Object.assign(customStreamOptions, options);
};
/**
 * 获取客户端流配置
 * @param streamType
 * @param isHigh
 * @param deviceName
 * @return {
 *   width,
 *   height,
 *   captureWidth,
 *   captureHeight,
 *   frameRate,
 *   bitRate: {
 *     minBitRate: 1000,
 *     maxBitRate: 3000,
 *   },
 * }
 */
const getClientStreamConfig = ({ streamType, isHigh = false, deviceName }) => {
  let conf;
  if (customStreamOptions.enable && customStreamOptions[streamType]) {
    conf = customStreamOptions[streamType];
  } else if (
    deviceName &&
    globalPageConfig[deviceName] &&
    globalPageConfig[deviceName][streamType]
  ) {
    conf = globalPageConfig[deviceName][streamType];
  } else if (isHigh) {
    conf =
      globalPageConfig.highPublishStreamConfig[streamType] ||
      globalPageConfig.publishStreamConfig[streamType];
  } else {
    conf = globalPageConfig.publishStreamConfig[streamType];
  }

  conf = {
    ...globalPageConfig.publishStreamConfig[streamType],
    ...conf,
  };
  conf.captureHeight = conf.captureHeight || conf.height;
  conf.captureWidth = conf.captureWidth || conf.width;
  conf.frameRate = conf.frameRate || globalPageConfig.zgConfig.frameRate;

  cacheStreamConfig[streamType] = conf;
  console.log('getClientStreamConfig', streamType, deviceName, conf);
  return conf;
};

const useConfig = () => {
  const { isGlobalPageConfigReady } = useGlobalStore();
  const stateful = useStateful(getConfig());
  useEffect(() => {
    stateful.setValue(getConfig());
  }, [isGlobalPageConfigReady]);
  return stateful.value;
};

export default {
  init,
  getConfig,
  useConfig,
  setCustomStreamOptions,
  getClientStreamConfig,
  getStreamSize,
};
